export default __webpack_public_path__ + "static/media/rabi_1.44bb73c4.jpg";